import type { FormContext, StepContext } from '../types'
import { TrackingEvent } from '../types'

export interface FormStartedArgs {
  formContext: FormContext
  stepContext?: StepContext
}

export interface FormStartedProperties {
  formContext: FormContext
  stepContext: StepContext
}

export class FormStarted extends TrackingEvent {
  properties: FormStartedProperties

  constructor(args: FormStartedArgs) {
    const {
      formContext = {
        formName: '',
        formType: '',
        formVersion: '',
        formId: '',
      },
      stepContext = {
        stepId: '',
        stepName: '',
        stepNumber: 0,
      },
    } = args ?? {}

    super('FormStarted', 'redventures.usertracking.v3.FormStarted')

    this.properties = {
      formContext: {
        formName: formContext.formName,
        formType: formContext.formType,
        formVersion: formContext.formVersion,
        formId: formContext.formId,
      },
      stepContext: {
        stepId: stepContext.stepId ?? '',
        stepName: stepContext.stepName ?? '',
        stepNumber: stepContext.stepNumber ?? 0,
      },
    }
  }
}
